import { ReactComponent as Minus } from "./svg/icon-minus.svg";

export const IconMinus = () => <Minus />;
